var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-navigation-drawer',{attrs:{"app":"","clipped":"","mobile-breakpoint":"700"},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }